var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loadState === 'failed')?_c('legacy-cta-after-impression'):_c('ds-audience-cta',{attrs:{"loading":_vm.loadState === 'loading'}})
}
var staticRenderFns = []

export { render, staticRenderFns }